import {GetBeersDTO} from 'typescript/dto/beersDto';
import {GetBreweriesDTO} from 'typescript/dto/BreweriesDto';
import {GetBeerPubsFilters} from 'typescript/dto/GetBeerPubsDTO';
import {GetPubsDTO} from 'typescript/dto/pubsDto';
import {DirectionType} from 'typescript/types/DirectionType';

type FilterTypes = GetBreweriesDTO | GetPubsDTO | GetBeersDTO | GetBeerPubsFilters;

type AllSortColumnTypes =
  | 'nickname'
  | 'country'
  | 'name'
  | 'city'
  | 'beer_style.name'
  | 'brewery.name'
  | 'brewery.country'
  | 'beer.name'
  | 'beer.brewery.name'
  | 'beer.brewery.country'
  | 'beer.beer_style.name';

export const handleQueryDirection = (column: AllSortColumnTypes, filters: FilterTypes): DirectionType => {
  let direction: DirectionType = 'asc';

  if (column === filters.column) {
    if (filters.direction === 'asc') direction = 'desc';
    else direction = 'asc';
  }

  return direction;
};
